import React from 'react';

import { getTruncateString } from '../utils/getters';

import Button from './Button';
import Tags from './Tags';
import Author from './Author';
import ArticleTime from './ArticleTime';

function ArticleInfo({ article }) {
  const { title, categories, markdownContent, author } = article;
  return (
    <>
      {article && (
        <div className="article-info">
          {markdownContent && <ArticleTime article={markdownContent} />}
          {categories && <Tags tags={categories.slice(0, 2)} />}
          {title && (
            <div className="article-info__title">
              <Button
                button={{
                  article,
                  version: 'tertiary-text',
                  label: getTruncateString(title, 100)
                }}
              />
            </div>
          )}
          {author && (
            <div className="article-info__author">
              <Author author={author} />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default ArticleInfo;
